import { getUser } from '@/services/user.services'
import { getJwt } from '@/shared/lib/betterAuth/get-jwt'
import {
  USER_QUERY_KEY,
  CACHE_GC_TIME,
  QUERY_NETWORK_MODE,
} from '@/shared/constants/cache'

export const userQueryOptions = {
  queryKey: USER_QUERY_KEY,
  queryFn: async () => {
    const token = await getJwt()
    if (!token) throw new Error('No JWT token')
    return getUser(token)
  },
  staleTime: 0,
  gcTime: CACHE_GC_TIME,
  networkMode: QUERY_NETWORK_MODE,
  refetchOnWindowFocus: true,
}
